// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__27d_H","search":"Settings_search__3TN0S","filter":"Settings_filter__9TKJF"};